<div class="row page-header">
    <div class="col-12">
        <h1>Vista Uploads <small>Detailed log of all Vista batch uploads and their results</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        @if (canViewDashboard) {
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>Dashboard</a>
            </li>
        }
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Upload Activity</a>
        </li>
    </ul>

    @if (canViewDashboard) {
        <div [hidden]="!isDashboardTab">
            <app-vista-uploads-dashboard></app-vista-uploads-dashboard>
        </div>
    }

    <div [hidden]="!isRecordsTab">
        <app-vista-uploads-list></app-vista-uploads-list>
    </div>
</div>
